let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2dAP4")).then(() => parcelRequire('23Ehe'));